<template>
    <el-table-column
            :prop="column.prop"
            :label="column.label"
            :resizable="false"
            align="center"
            :render-header="renderHeader"
            :width="column.width">
        <template v-if="column.children">
            <base-my-column v-for="(item, index) in column.children" :key="index" :column="item"></base-my-column>
        </template>
    </el-table-column>
</template>
<style lang="scss" scoped>
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/base-components/my-column/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/base-components/my-column/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/base-components/my-column/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-base-my-column')
  export default {
    name: 'base-my-column', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'base-my-column': require('%path').default,
       */
      /*start:import components file*/
/*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>